import {
  container,
  title,
  main,
  mainRaised,
  mlAuto,
  description,
} from "assets/jss/material-kit-pro-react";

import contentAreasStyle from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.js";
import customSelectStyle from "assets/jss/material-kit-pro-react/customSelectStyle";

const contactUsStyle = {
  ...contentAreasStyle,
  ...customSelectStyle,
  main,
  mainRaised,
  title,
  mlAuto,
  description,
  container: {
    ...container,
    // marginTop: "-30px",
    maxWidth: "auto !important"
  },
  contactContent: {
    marginTop:'150px',
    paddingBottom: "40px",
    paddingTop: "40px"
  },
  bigMap: {
    height: "55vh",
    maxHeight: "550px",
    width: "100%",
    display: "block"
  },
  info: {
    paddingBottom: "10px",
    paddingTop: 0
  },
  textCenter: {
    textAlign: "center !important"
  },
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right"
  },
  icon: {
    width: "18px",
    height: "18px",
    top: "3px",
    position: "relative"
  },
  justifyContentCenter: {
    "& > ul": {
      justifyContent: "center!important"
    }
  },
  grid:{
    marginTop:20
  },
  oddRow : {
		backgroundColor:'#e8f4f7'
	},
	evenRow :{
		backgroundColor:'#cbe3ee'
	},
  
};

export default contactUsStyle;
